import { Stack, Typography } from "@mui/material";

interface HeroSectionProps {
  title: string;
  subtitle: string;
}

const HeroSection = ({ title, subtitle }: HeroSectionProps) => {
  return (
    <Stack
      sx={{
        pt: { xs: "120px", sm: "160px", md: "200px" },
        pb: { xs: "40px", sm: "50px", md: "70px" },
        px: { xs: 3, sm: 4, md: 0 }, 
        alignItems: "center",
      }}
      spacing={{ xs: 2, md: 3 }}
    >
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 900,
          fontSize: { xs: "42px", sm: "42px", md: "56px" },
          color: "primary.main",
          textAlign: "center",
          lineHeight: { xs: "40px", sm: "50px", md: "64px" },
          maxWidth: { xs: "100%", md: "765px" },
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 400,
          fontSize: { xs: "15px", md: "16px" },
          color: "black",
          textAlign: "center",
          maxWidth: { xs: "90%", md: "none" },
        }}
      >
        {subtitle}
      </Typography>
    </Stack>
  );
};

export default HeroSection;